const breakpoints = {
    xs: '0px',
    sm: '599.9px',
    md: '899.9px',
    lg: '1199.9px',
    xl: '1535.99px',
    xxl: '1919.99px',
};

export const media = {
    xs: {
        min: '@media (min-width: 320px)',
        max: '@media (max-width: 480px)',
    },
    sm: {
        min: '@media (min-width: 481px)',
        max: '@media (max-width: 768px)',
    },
    md: {
        min: '@media (min-width: 769px)',
        max: '@media (max-width: 1024px)',
    },
    lg: {
        min: '@media (min-width: 1025px)',
        max: '@media (max-width: 1200px)',
    },
    xl: {
        min: '@media (min-width: 1201px)',
        max: '@media (max-width: 1440px)',
    },
};
export { breakpoints };
